import styled from "styled-components";

export const Container = styled.div`
  padding-top: 5em;
`;
export const HeaderImage = styled.div`
  width: 100%;
  height: 10.1875rem;
  background: #bedfff;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    height: 8.0625rem;
  }
`;
export const OverLay = styled.div`
  position: absolute;
  width: 100%;
  overflow: auto;
  top: 0;
`;
export const Heading = styled.div`
  width: 4em;
  height: 4em;
  margin: 4em auto;
  border-radius: 50%;
  overflow: hidden;
`;
export const Card = styled.form`
  width: 22.375rem;
  border-radius: 0.375rem;
  background: #fff;
  box-shadow: 0px 0px 15px 0px rgba(217, 217, 217, 0.25);
  margin: 0 auto;
  padding: 2em 2.19em;
  h1 {
    margin: 2em auto;
    margin-top: 0;
    text-align: center;
    color: #3f3f3f;

    font-size: 0.875rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  @media (max-width: ${({ theme }) => theme.mobile.md}) {
  }
`;
export const AmountContainer = styled.div`
  width: 18.1875rem;
  flex-shrink: 0;
  border-radius: 0.25rem;
  border: 1px solid #dfdfdf;
  background: #fff;
  display: flex;
  margin: 0.5em auto;

  div {
    height: 2.5rem;
    display: flex;
    align-items: center;
    width: 4.0625rem;
    height: 2.5rem;
    flex-shrink: 0;
    border-radius: 0.15rem;
    background: #000;
    color: #fff;

    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    p {
      text-align: center;
      width: 100%;
    }
  }
`;
export const Amount = styled.input`
  width: 100%;
  outline: none;
  height: 2.5rem;
  padding: 0.87em;
`;
export const Number = styled.input`
  width: 18.125rem;
  height: 2.875rem;
  flex-shrink: 0;
  margin: 0.5em auto;
  border-radius: 0.5625rem;
  border: 1px solid #d1d1d1;
  background: #fff;
  padding: 0.6em;
`;
export const Next = styled.input`
  width: 18rem;
  height: 2.25rem;
  flex-shrink: 0;
  cursor: pointer;
  margin: 1em auto;
  border-radius: 0.25rem;
  background: #351182;
  padding: 0.6em;
  color: #fff;

  font-size: 0.875rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;
export const TextArea = styled.textarea`
  width: 18.0625rem;
  height: 7.125rem;
  flex-shrink: 0;
  margin: 0.5em auto;
  border-radius: 0.25rem;
  border: 1px solid #dfdfdf;
  background: #fff;
  padding: 0.6em;
`;
